class EdsSignBlock {
    constructor(
        $rootScope,
        $state,
        $timeout,
        documentsService,
        monitoringService,
        agreementService,
        agreementInstanceService,
        ntFlash,
        profileService,
        http,
        $http,
        $scope
    ) {
        this.$rootScope = $rootScope;
        this.profileService = profileService;
        this.$scope = $scope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.documentsService = documentsService;
        this.monitoringService = monitoringService;
        this.agreementService = agreementService;
        this.agreementInstanceService = agreementInstanceService;
        this.ntFlash = ntFlash;
        this.baseUrl = OPC_CONFIG.OPC_API_PUBLIC_BASE_URL;
        this.monitUrl = OPC_CONFIG.OPC_API_MONITORING_PUBLIC_BASE_URL;
        this.ErrorDrfo = false
        this.http = http
        this.$http = $http
        this.ProzorroEds = window.ProzorroEds
        this.euSign = null
        this.certificate = null
        this.SignBtn = false
        this.showSignWidget = true
        this.showQrCode = false
        this.showDebugSignData = false
        this.debugDataToSign = ''
        this.debugSignature = ''
        this.isSigning = false
        this.edsEnvironmentName = this.resolveEdsEnvironmentName()
        this.edsEnvironment = this.getEdsEnvironment(this.edsEnvironmentName)
        this.prozorroEdsDiagnostics = []
    }

    getProzorroEds() {
        return this.ProzorroEds || window.ProzorroEds;
    }

    installProzorroEdsDiagnostics() {
        if (window.__newtendProzorroEdsDiagnosticsInstalled) {
            return;
        }

        window.__newtendProzorroEdsDiagnosticsInstalled = true;
        window.__newtendProzorroEdsDiagnostics = [];

        window.addEventListener('message', (event) => {
            const data = event && event.data;

            if (!data || data.cmd !== 'SignData' || !data.error) {
                return;
            }

            window.__newtendProzorroEdsDiagnostics.push({
                date: new Date().toISOString(),
                origin: event.origin,
                id: data.id,
                cmd: data.cmd,
                error: this.normalizeForLog(data.error),
            });

            window.__newtendProzorroEdsDiagnostics = window.__newtendProzorroEdsDiagnostics.slice(-10);
        });
    }

    $onInit() {
        if (window.autotest_mode) {
            this.SignBtn = true;
            this.imitateSigning();
        } else {
            this.initSign()
        }

    }

    autoTest(){
        return  window.autotest_mode
    }

    getEndUser() {
        return window.EndUser;
    }

    getEdsEnvironments() {
        return {
            production: {
                widgetUrl: 'https://id.gov.ua/sign-widget/v20220527/',
                apiSign: {
                    login: 'eds',
                    pass: '0ecac9a6fb8f4c7c99721f812bea88e5',
                    url: 'https://api-sign.prozorro.gov.ua/'
                }
            },
            development: {
                widgetUrl: 'https://eu.iit.com.ua/sign-widget/v20240301_new/',
                apiSign: {
                    login: 'test',
                    pass: 'test',
                    url: 'https://api-sign-np.prozorro.gov.ua/'
                }
            }
        };
    }

    resolveEdsEnvironmentName() {
        const configuredEnvironment =
            (OPC_CONFIG && OPC_CONFIG.OPC_EDS_ENVIRONMENT) ||
            (window.options && window.options.environment);

        if (configuredEnvironment === 'production' || configuredEnvironment === 'development') {
            return configuredEnvironment;
        }

        if (
            window.location &&
            /^(localhost|127\.0\.0\.1|0\.0\.0\.0)$/i.test(window.location.hostname)
        ) {
            return 'development';
        }

        return 'production';
    }

    getEdsEnvironment(environmentName) {
        const environments = this.getEdsEnvironments();
        return environments[environmentName] || environments.production;
    }

    getSignWidgetUrl() {
        return this.edsEnvironment.widgetUrl;
    }

    createEndUserWidget(formType) {
        const EndUser = this.getEndUser();

        if (!EndUser) {
            throw new Error('EndUser не знайдено. Перевір підключення eusign.js');
        }

        if (!EndUser.FormType) {
            throw new Error('EndUser.FormType не знайдено');
        }

        this.destroyEndUserWidget();

        const formParams = new EndUser.FormParams();
        formParams.language = 'ua';
        formParams.showPKInfo = true;
        formParams.showSignTip = true;

        this.euSign = new EndUser(
            'sign-widget-parent',
            'sign-widget',
            this.getSignWidgetUrl(),
            formType,
            formParams
        );

        return this.euSign;
    }

    destroyEndUserWidget() {
        if (this.euSign && typeof this.euSign.destroy === 'function') {
            try {
                this.euSign.destroy();
            } catch (error) {
                console.warn('[EDS] destroyEndUserWidget error:', error);
            }
        }

        this.euSign = null;
    }

    initSign(){
        this.SignBtn = false;
        this.ErrorDrfo = false;
        this.showSignWidget = true;
        this.showQrCode = false;

        if (window.autotest_mode) {
            this.SignBtn = true;
            this.imitateSigning();
            return;
        }

        try {
            const EndUser = this.getEndUser();

            if (!EndUser) {
                this.ntFlash.error(gettext('Помилка завантаження підпису'));
                console.error('EndUser is not available. Check eusign.js');
                return;
            }

            const euSign = this.createEndUserWidget(EndUser.FormType.ReadPKey);

            euSign.AddEventListener(
                EndUser.EventType.ConfirmKSPOperation,
                (event) => this.onConfirmKSPOperation(event)
            )
                .then(() => euSign.ReadPrivateKey())
                .then((certificates) => {
                    this.certificate = certificates || [];

                    if (this.certificate[0] && this.certificate[0].infoEx) {
                        this.checkCompany(this.certificate[0].infoEx);
                    }

                    this.$scope.$applyAsync(() => {
                        this.showQrCode = false;
                        // this.showSignWidget = false;
                        this.SignBtn = true;
                    });
                })
                .catch((error) => {
                    this.ntFlash.error(gettext('Помилка завантаження підпису'));
                    console.error('[EDS] initSign error:', error);

                    this.$scope.$applyAsync(() => {
                        this.SignBtn = false;
                    });
                });
        } catch (error) {
            this.ntFlash.error(gettext('Помилка завантаження підпису'));
            console.error('[EDS] initSign fatal error:', error);
        }
    }

    onConfirmKSPOperation(event) {
        const qrBlock = document.getElementById('qr-code-block');

        if (!qrBlock) {
            return;
        }

        const qrCode = event.qrCode || event.qrImage;

        if (!qrCode) {
            return;
        }

        let node = '';
        node += '<a href="' + event.url + '">';
        node += '<img src="data:image/bmp;base64,' + qrCode + '" style="padding: 10px; background: white;">';
        node += '</a>';

        qrBlock.innerHTML = node;

        this.$scope.$applyAsync(() => {
            this.showQrCode = true;
        });
    }

    hideQrCode() {
        const qrBlock = document.getElementById('qr-code-block');

        if (qrBlock) {
            qrBlock.innerHTML = '';
        }

        this.$scope.$applyAsync(() => {
            this.showQrCode = false;
        });
    }

    normalizeForLog(data, seen) {
        if (data === null || typeof data === 'undefined') {
            return data;
        }

        if (!seen) {
            seen = [];
        }

        if (typeof data !== 'object') {
            return data;
        }

        if (seen.indexOf(data) !== -1) {
            return '[Circular]';
        }

        seen.push(data);

        const result = {};

        if (data.name) {
            result.name = data.name;
        }

        if (data.message) {
            result.message = data.message;
        }

        if (data.code) {
            result.code = data.code;
        }

        if (data.stack) {
            result.stack = data.stack;
        }

        Object.keys(data).forEach((key) => {
            if (typeof result[key] === 'undefined') {
                result[key] = this.normalizeForLog(data[key], seen);
            }
        });

        result.asString = String(data);

        return result;
    }

    stringifyForLog(data) {
        try {
            return JSON.stringify(this.normalizeForLog(data));
        } catch (error) {
            return `[JSON stringify error: ${error && error.message ? error.message : error}]`;
        }
    }

    getSignOptions(options) {
        const EndUser = this.getEndUser();
        const signOptions = options || {};

        return {
            external: !!signOptions.external,
            asBase64String: !!signOptions.asBase64String,
            signAlgo: signOptions.signAlgo || EndUser.SignAlgo.DSTU4145WithGOST34311,
            previousSign: signOptions.previousSign || null,
            signType: signOptions.signType || EndUser.SignType.CAdES_X_Long
        };
    }

    normalizeSignData(data) {
        if (data instanceof ArrayBuffer) {
            return new Uint8Array(data);
        }

        if (
            typeof data === 'string' ||
            data instanceof Uint8Array ||
            data instanceof Array
        ) {
            return data;
        }

        if (data && typeof data === 'object') {
            return JSON.stringify(data);
        }

        return String(data);
    }

    signData(data, options) {
        if (this.isSigning) {
            return Promise.reject(new Error('Підпис вже виконується'));
        }

        if (!this.euSign || typeof this.euSign.SignData !== 'function') {
            return Promise.reject(new Error('EndUser SignData не ініціалізований'));
        }

        const signOptions = this.getSignOptions(options);
        console.log(signOptions)
        console.log(data)
        let payload;

        try {
            payload = this.normalizeSignData(data);
        } catch (error) {
            return Promise.reject(new Error('Не вдалося підготувати дані для підпису'));
        }

        this.isSigning = true;
        this.debugDataToSign = typeof payload === 'string' ? payload : `[${Object.prototype.toString.call(payload)}]`;

        return this.euSign
            .SignData(
                payload,
                signOptions.external,
                signOptions.asBase64String,
                signOptions.signAlgo,
                signOptions.previousSign,
                signOptions.signType
            )
            .then((signature) => {
                this.debugSignature = signature;
                this.hideQrCode();

                return signature;
            })
            .catch((error) => {
                console.error('[EDS] SignData error:', error);

                const normalizedError = this.normalizeForLog(error);
                const signError = new Error(
                    `Помилка підпису EndUser.SignData: ${error && error.message ? error.message : this.stringifyForLog(error)}`
                );

                signError.originalError = normalizedError;
                signError.signPayloadInfo = {
                    payloadLength: payload && payload.length ? payload.length : null,
                    signDataType: Object.prototype.toString.call(payload),
                    signOptions,
                };

                throw signError;
            })
            .then((result) => {
                this.isSigning = false;
                return result;
            }, (error) => {
                this.isSigning = false;
                return Promise.reject(error);
            });
    }

    signProzorroData(signData) {
        let payload;

        try {
            payload = JSON.stringify(signData);
        } catch (error) {
            return Promise.reject(new Error('Не вдалося перетворити sign_data в JSON'));
        }

        return this.signData(payload, {
            external: false,
            asBase64String: true
        }).catch((error) => {
            if (error && error.signPayloadInfo) {
                error.signPayloadInfo.signDataKeys = signData && typeof signData === 'object' ? Object.keys(signData) : null;
            }

            return Promise.reject(error);
        });
    }

    signBidData(signData) {
        const publicSignData = angular.copy(signData);

        if (publicSignData.data) {
            delete publicSignData.data.value;
            delete publicSignData.data.lotValues;
            (publicSignData.data.items || []).forEach((item) => {
                if (item && item.unit) {
                    delete item.unit.value;
                }
            });
        }

        return this.signProzorroData(publicSignData)
            .then((publicSignature) => {
                return this.signProzorroData(signData)
                    .then((financialSignature) => [publicSignature, financialSignature]);
            });
    }

    readFileAsUint8Array(file) {
        return new Promise((resolve, reject) => {
            const fr = new FileReader();

            fr.onload = (e) => {
                resolve(new Uint8Array(e.target.result));
            };

            fr.onerror = reject;
            fr.readAsArrayBuffer(file);
        });
    }

    signFile(file) {

        return this.readFileAsUint8Array(file)
            .then((array) => {
                return this.signData(array,{
                    external: false,
                    asBase64String: false
                })
            })
            .then((signature) => {
                const signBlob = new Blob([signature], {
                    type: 'application/pkcs7-signature'
                });

                return new File(
                    [signBlob],
                    `${file.name}.p7s`,
                    {
                        type: 'application/pkcs7-signature'
                    }
                );
            });
    }

    signFiles(files) {
        const result = [];

        return (files || []).reduce((promise, file) => {
            return promise
                .then(() => this.signFile(file))
                .then((signedFile) => {
                    result.push(signedFile);
                    return result;
                });
        }, Promise.resolve(result));
    }

    verifySignature(signature) {
        const apiSign = this.edsEnvironment.apiSign;
        const authString = `${apiSign.login}:${apiSign.pass}`;
        const authHeader = `Basic ${window.btoa(unescape(encodeURIComponent(authString)))}`;

        return this.$http({
            method: 'POST',
            url: `${apiSign.url}verify_data_internal`,
            headers: {
                Authorization: authHeader
            },
            data: {
                sign: signature
            }
        }).then((response) => {
            return response.data;
        });
    }


    sign(){
        const links = this.initOptions()
        console.log('links', this.$rootScope.edsDataSign)
        if (window.autotest_mode) {

            links.forEach((el)=>{
                const signature = this.imitateSigning();
                this.postSign(this.doubleSign && this.bidId ? [signature, signature] : signature)
            })

        } else if(this.$rootScope.edsDataSign){
            this.signProzorroData(this.$rootScope.edsDataSign)
                .then((data)=>{
                    const file =  this.singleSign(data)
                    this.close(file)
                })
                .catch((error)=>{
                    this.ntFlash.error(gettext('Помилка завантаження підпису'));
                    console.log(error)
                });
        } else {

            links.reduce((promise, el)=>{
                return promise.then(() => {
                    return this.$http.get(`${el}`)
                    .then((response) => {
                        if(response.data.sign_data){
                           if (this.doubleSign && this.bidId) {
                               return this.signBidData(response.data.sign_data);
                           }
                           return this.signProzorroData(response.data.sign_data)
                        }
                        return Promise.reject(new Error(response))
                    })
                .then((data)=>{
                    this.postSign(data)

                })
                .catch((error)=>{
                    const errorData  = {
                            currentUrl: `${location.href}`,
                            additionalError: null,
                            message: 'Error from sign b2b',
                            requestUrl: el,
                            responseCode: '',
                            user: null,
                            requestAction: 'b2b_sign_error',
                            requestData: error ? this.stringifyForLog({
                                message: error.message,
                                stack: error.stack,
                                raw: error,
                                originalError: error.originalError,
                                signPayloadInfo: error.signPayloadInfo,
                                prozorroEdsDiagnostics: error.prozorroEdsDiagnostics,
                            }) : null,
                            date: new Date(),
                        }
                        console.log(error)
                        this.sendError(errorData)
                    this.ntFlash.error(gettext('Помилка завантаження підпису'));
                });
                });
            }, Promise.resolve())

        }
    }

    getSign(){
        return this.signFiles(this.documents)
            .then((response)=>{
                this.close(response);
            })
            .catch((error) => {
                console.error('EndUser SignData file error:', error);
                this.ntFlash.error(gettext('Помилка підпису документів'));
            });

    }

    checkPersonSign(){
        if (window.autotest_mode) {
            this.profileService.setUo('test')
            if(typeof this.checkPersonCallback == 'function'){
                this.checkPersonCallback('test')
                this.close({ap: true})
            } else {
                this.AP = true
                this.sign()
            }
        } else {
            let drfo = this.certificate[0].infoEx.subjDRFOCode
            console.log('AuthorityPerson.certificate', this.certificate)
            // console.log('AuthorityPerson.DRFO', drfo)

            this.profileService.setUo('temp sign')
            const now2 = new Date()
            if(typeof this.checkPersonCallback == 'function'){
                this.checkPersonCallback(now2.getTime())
                this.close({ap: true})
            } else {
                this.AP = true
                this.sign()
            }


            // return this.profileService.UoAuthorityRequest(drfo)
            //     .then((data)=>{
            //         // if( data.data.certified_at && data.data.certified_at !== null){
            //         //     this.profileService.setUo(data)
            //         //     if(typeof this.checkPersonCallback == 'function'){
            //         //         this.checkPersonCallback(data.data.certified_at)
            //         //         this.close({ap: true})
            //         //     } else {
            //         //         this.AP = true
            //         //         this.sign()
            //         //     }
            //         // } else {
            //         //     this.$rootScope.edsSignSetup.reload = false
            //         //     this.ntFlash.error(gettext('Проверка на Уповноважену Особу отклонена'));
            //         //     this.$timeout(() => {
            //         //         this.close({ap: false})
            //         //     }, 1000)
            //         // }
            //
            //
            //         const now2 = new Date()
            //         if(typeof this.checkPersonCallback == 'function'){
            //             this.checkPersonCallback(now2.getTime())
            //             this.close({ap: true})
            //         } else {
            //             this.AP = true
            //             this.sign()
            //         }
            //
            //     })
            //     .catch((error)=>{
            //         this.ntFlash.error(gettext('Проверка на Уповноважену Особу отклонена'));
            //         this.close({ap: false})
            //     })

        }
    }


    checkCompany(certificate){
        // const company =
        const _this = this
        // console.log()
        if(this.checkCompany$) {
            this.profileService.getCompany()
                .then((res) => {
                    const companyId = res.data.registration_number
                    const userDrfo = certificate.subjDRFOCode
                    const userEDRPOU = certificate.subjEDRPOUCode

                    if (companyId != userDrfo && companyId != userEDRPOU) {
                        _this.ErrorDrfo = true
                    }
                });
        }
    }



    $onChanges(changes) {

        if (changes.edsSignIsOpened.currentValue) {
            if(this.$rootScope.edsSignSetup.setSign){
                this.setSign = this.$rootScope.edsSignSetup.setSign
            }
            if(this.$rootScope.edsSignSetup.checkPerson){
                this.checkPersonCallback  = this.$rootScope.edsSignSetup.checkPerson
                this.checkPerson = true
                this.AP = false
            }
            this.checkCompany$ = false

            if(this.$rootScope.edsSignSetup.checkCompany){
                this.checkCompany$ = this.$rootScope.edsSignSetup.checkCompany
            }

            this.open();
        }

    }

    open() {
        this.doubleSign = !this.setSign && !!(this.edsSignData && this.edsSignData.doubleSign === true);
        if(!this.setSign && this.edsSignData != null){
            this.documents = this.edsSignData.documents || [];
            this.financialDocuments = this.edsSignData.financialDocuments;
            this.tenderId = this.edsSignData.tenderId;
            this.complaintURL = this.edsSignData.complaintURL;
            this.planId = this.edsSignData.planId;
            this.milestoneId = this.edsSignData.milestoneId;
            this.awardId = this.edsSignData.awardId;
            this.agreementId = this.edsSignData.agreementId;
            this.agreementInstanceId = this.edsSignData.agreementInstanceId;
            this.contractId = this.edsSignData.contractId;
            this.qualificationId = this.edsSignData.qualificationId;
            this.complaintId = this.edsSignData.complaintId;
            this.bidId = this.edsSignData.bid && this.edsSignData.bid.id;
            this.documentsType = this.edsSignData.documentsType;
            this.monitoringId = this.edsSignData.monitoringId;
            this.cancellationId = this.edsSignData.cancellationId;
            this.postId = this.edsSignData.postId;
            this.entity = this.edsSignData.entity;
            this.skipPublic = this.edsSignData.skipPublic;
            this.callback = this.edsSignData.callback;
            this.complaintDOCURL = this.edsSignData.complaintDOCURL;
        } else {
            this.documents = this.edsSignData || [];
        }


        angular.element('body').addClass('modal-open').css('padding-right', '17px');
    }

    openFileSignWidget() {
        try {
            const EndUser = this.getEndUser();

            if (!EndUser) {
                this.ntFlash.error(gettext('Помилка завантаження підпису'));
                return;
            }

            this.SignBtn = false;
            this.showQrCode = false;
            this.showSignWidget = true;

            this.createEndUserWidget(EndUser.FormType.SignFile);

            this.ntFlash.success(gettext('Віджет підпису файлу відкрито'));
        } catch (error) {
            console.error('[EDS] openFileSignWidget error:', error);
            this.ntFlash.error(gettext('Помилка відкриття підпису файлу'));
        }
    }

    refresh() {
        try {
            if (this.euSign && typeof this.euSign.ResetPrivateKey === 'function') {
                this.euSign.ResetPrivateKey();
            }

            this.destroyEndUserWidget();

            this.SignBtn = false;
            this.showSignWidget = true;
            this.showQrCode = false;

            this.$timeout(() => {
                this.initSign();
            }, 0);
        } catch (error) {
            console.error('[EDS] refresh error:', error);
            this.ntFlash.error(gettext('Помилка оновлення підпису'));
        }
    }

    close(response) {

        this.refresh()
      this.$timeout(() => {
        this.SignBtn = false
        this.$rootScope.edsSignIsOpened = false;
          this.setSign = false;
          this.checkPerson = false;
        if (this.onResolved) this.onResolved({response});
        //TODO check works
        if(this.$rootScope.edsSignSetup.reload){
            if (response) this.$state.reload();
        }

          if(this.$rootScope.edsSignSetup.mustReload){
              this.$state.reload();
          }

        //
      }, 500);
      angular.element('body').removeClass('modal-open').css('padding-right', '0');
    }

    imitateSigning() {
        // let signature = 'ImitateSigning'
        console.log('ImitateSigning');
        // this.postSign(signature);
        return  '!!! Test happens !!! A.P.A.B. !!!';
    }
  
    initOptions() {
        const options = {
            placeholderId: "#signPlaceholder",
            callbackPostSign: "postSign",
            ...window.options,
            apiResourceUrl:[]
        };

        if (this.monitoringId && this.entity === 'post') {
            options.apiResourceUrl.push(`/opc/tender/${this.tenderId}/monitorings/${this.monitoringId}/posts/${this.postId}/?for_sign=true`);
        } else if (this.monitoringId && this.entity === 'eliminationReport') {
            options.apiResourceUrl.push(`/opc/tender/${this.tenderId}/monitorings/${this.monitoringId}/eliminationReport/?for_sign=true`);
        } else if (this.monitoringId && this.entity === 'appeal') {
            options.apiResourceUrl.push(`/opc/tender/${this.tenderId}/monitorings/${this.monitoringId}/appeal/?for_sign=true`);
        } else if (this.qualificationId) {
            options.apiResourceUrl.push(`${this.baseUrl}/tenders/${this.tenderId}/qualifications/${this.qualificationId}`);
        } else if (this.contractId && this.awardId) {
            options.apiResourceUrl.push(`/opc/tender/${this.tenderId}/contracts/${this.contractId}/?for_sign=true`);
        } else if (this.complaintURL) {
            options.apiResourceUrl.push(`/${this.complaintURL}/?for_sign=true`);
        } else if (this.contractId) {
            options.apiResourceUrl.push(`/opc/contracts/${this.contractId}/?for_sign=true`);
        } else if (this.awardId) {
            options.apiResourceUrl.push(`/opc/tender/${this.tenderId}/awards/${this.awardId}/?for_sign=true`);
        } else if (this.agreementId) {
            options.apiResourceUrl.push(`${this.baseUrl}/tenders/${this.tenderId}/agreements/${this.agreementId}`);
        } else if (this.agreementInstanceId) {
            options.apiResourceUrl.push(`${this.baseUrl}/agreements/${this.agreementInstanceId}`);
        } else if (this.bidId) {
            if (this.doubleSign) {
                options.apiResourceUrl.push(`/opc/tender/${this.tenderId}/bid/${this.bidId}/?private_mode=all&opt_context=true`);
            } else if (this.financialDocuments instanceof Array) {
                options.apiResourceUrl.push(`/opc/tender/${this.tenderId}/bid/${this.bidId}/?private_mode=onlyPublic&opt_context=true`);
                options.apiResourceUrl.push(`/opc/tender/${this.tenderId}/bid/${this.bidId}/?private_mode=onlyPrivate&opt_context=true`)

            } else {
                options.apiResourceUrl.push(`/opc/tender/${this.tenderId}/bid/${this.bidId}/?private_mode=all&opt_context=true`);
            }
        } else if (this.tenderId && this.cancellationId) {
            options.apiResourceUrl.push(`/opc/tender/${this.tenderId}/cancel/${this.cancellationId}/?for_sign=true&opt_context=true`);
        } else if (this.tenderId) {
            options.apiResourceUrl.push(`/opc/tender/${this.tenderId}/?for_sign=true`);
            // http://api-url.com/tenders/;sldkf;ldfghd
        } else if (this.planId && this.milestoneId) {
            options.apiResourceUrl.push(`/opc/plans/${this.planId}/milestones/${this.milestoneId}?for_sign=true`);
        } else if (this.planId) {
            options.apiResourceUrl.push(`/opc/plans/${this.planId}?for_sign=true`);
        }
        return options.apiResourceUrl;
    }

    singleSign(signature) {
        let request = null,
            signFile, signBlob;
        signBlob = new Blob([signature]);
            signFile = new File([signBlob], `sign.p7s`, {
                type: 'application/pkcs7-signature'
            });
            return signFile;
    }

    postSign(signature) {

        const getSignFileId = function(docs) {
          let s = null;
          (docs || []).forEach((document) => {
              if (document.title === 'sign.p7s' && document.format === 'application/pkcs7-signature') {
                  s = document.id;
              }
          });
          return s;
        }

        let isMultiSign = signature instanceof Array;

        let request = null,
            signFile, signBlob;

        if (!isMultiSign) {
            signBlob = new Blob([signature]);
            signFile = new File([signBlob], `sign.p7s`, {
                type: 'application/pkcs7-signature'
            });
        } else {
            signFile = [];
            for (const key in signature) {
                if (signature.hasOwnProperty(key)) {
                    signBlob = new Blob([signature[key]]);
                    signFile.push(new File([signBlob], 'sign.p7s', {
                        type: 'application/pkcs7-signature'
                    }));
                }
            }
        }

        if (this.monitoringId) {
            if (this.entity === 'post') {
                request = this.documentsService.uploadToDocumentService([signFile])
                    .then((res) => {
                        return this.monitoringService.addPostDocument(this.tenderId, this.monitoringId, this.postId, res[0]);
                    });
            } else if (this.entity === 'eliminationReport') {
                request = this.documentsService.uploadToDocumentService([signFile])
                    .then((res) => {
                        return this.monitoringService.addViolationEliminationDocument(this.tenderId, this.monitoringId, res[0]);
                    });
            } else if (this.entity === 'appeal') {
                request = this.documentsService.uploadToDocumentService([signFile])
                    .then((res) => {
                        return this.monitoringService.addDocumentToAppeal(this.tenderId, this.monitoringId, res[0]);
                    });
            }
            request.then((response) => {
                if (response) {
                    this.documents.push(response);
                    this.ntFlash.success(gettext('Моніторинг підписано'));
                    this.close(response);
                } else {
                    this.ntFlash.success(gettext('Помилка завантаження цифрового підпису'));
                }
            });
        } else if (this.agreementId) {
            request = this.documentsService.uploadToDocumentService([signFile])
                .then((res) => {
                    return this.agreementService.uploadDocument({
                        tenderId: this.tenderId,
                        agreementId: this.agreementId
                    }, res[0]);
                });
            request.then((response) => {
                if (response) {
                    this.documents.push(response);
                    this.ntFlash.success(gettext('Угода підписана'));
                    this.close(response);
                } else {
                    this.ntFlash.success(gettext('Помилка завантаження цифрового підпису'));
                }
            });
        }
        // todo remake #1
        else if (this.agreementInstanceId) {
            request = this.documentsService.uploadToDocumentService([signFile])
                .then((res) => {
                    res[0].documentOf = 'agreement'
                    return this.agreementInstanceService.documentUpload(this.agreementInstanceId, res[0]);
                });
            request.then((response) => {
                if (response) {
                    this.documents.push(response);
                    this.ntFlash.success(gettext('Угода підписана'));
                    this.close(response);
                } else {
                    this.ntFlash.success(gettext('Помилка завантаження цифрового підпису'));
                }
            });

        } else {
            const signId = getSignFileId(this.documents);
            if (this.qualificationId) {
                request = signId ?
                    this.documentsService.replace(signFile, this.tenderId, signId, {
                        qualificationId: this.qualificationId
                    }) :
                    this.documentsService.save(signFile, this.tenderId, {
                        qualificationId: this.qualificationId
                    });
            } else if (this.contractId && this.awardId) {
                request = signId ?
                    this.documentsService.replace(signFile, this.tenderId, signId, {
                        awardId: this.awardId,
                        contractId: this.contractId
                    }) :
                    this.documentsService.save(signFile, this.tenderId, {
                        awardId: this.awardId,
                        contractId: this.contractId
                    });
            } else if (this.contractId) {
                request = signId ?
                    this.documentsService.replace(signFile, null, signId, {
                        contractId: this.contractId
                    }) :
                    this.documentsService.save(signFile, null, {
                        contractId: this.contractId
                    });
            } else if (this.awardId) {
                request = signId ?
                    this.documentsService.replace(signFile, this.tenderId, signId, {
                        awardId: this.awardId
                    }) :
                    this.documentsService.save(signFile, this.tenderId, {
                        awardId: this.awardId,
                        docData: {

                            documentType: this.$rootScope.edsSignSetup.documentType ? this.$rootScope.edsSignSetup.documentType : 'notice'

                        }
                    });


                // request = signId ?
                //     this.documentsService.replace(signFile, this.tenderId, signId) :
                //     this.documentsService.save(signFile, this.tenderId, {docData: {
                //             documentType: this.$rootScope.edsSignSetup.documentType ? this.$rootScope.edsSignSetup.documentType : 'notice'
                //
                //         }
                //     });

            } else if (this.complaintURL) {
                request =
                    this.documentsService.save(signFile, this.tenderId, {
                        complaintId: this.complaintId,
                        complaintDOCURL: this.complaintDOCURL,
                    });
            }
            else if (this.bidId) {

                const fileData = {
                    documentOf: "tender",
                }
                if(this.$rootScope.edsSignSetup.documentType){
                    fileData.documentType = this.$rootScope.edsSignSetup.documentType
                }

                if (!isMultiSign) {

                    if(this.documentsType === 'financial_documents'){
                        const signFinDocId = getSignFileId(this.financialDocuments);
                        fileData.type = 'financialDocuments'
                        request = signFinDocId ?
                            this.documentsService.replace(signFile, this.tenderId, signFinDocId, {
                                bidId: this.bidId,
                                docData: fileData,
                                documentsType: 'financialDocuments'
                            }) :
                            this.documentsService.saveBid(signFile, this.tenderId, {
                                bidId: this.bidId,
                                docData: fileData
                            });
                    } else {
                        request = signId ?
                            this.documentsService.replace(signFile, this.tenderId, signId, {
                                bidId: this.bidId,
                                docData: fileData
                            }) :
                            this.documentsService.saveBid(signFile, this.tenderId, {
                                bidId: this.bidId,
                                docData: fileData
                            });
                    }


                } else {
                    let uploadPromises = [];


                    // Sign without value for pre-qualification procedures and full data for other procedures
                    if (!this.skipPublic) {
                        uploadPromises.push(signId ?
                            this.documentsService.replace(signFile[0], this.tenderId, signId, {
                                bidId: this.bidId,
                                docData: fileData
                            }) :
                            this.documentsService.saveBid(signFile[0], this.tenderId, {
                                bidId: this.bidId,
                                docData: fileData
                                // docData:
                            }));
                    }

                    // Sign with value for pre-qualification procedures
                    if (signFile.length > 1) {
                        const signFinId = getSignFileId(this.financialDocuments);
                        const financialFileData = {...fileData, type: 'financialDocuments'};

                        uploadPromises.push(signFinId ?
                            this.documentsService.replace(signFile[1], this.tenderId, signFinId, {
                                bidId: this.bidId,
                                docData: financialFileData,
                                documentsType: 'financialDocuments'
                            }) :
                            this.documentsService.saveBid(signFile[1], this.tenderId, {
                                bidId: this.bidId,
                                docData: financialFileData
                            }))
                    }
                    request = Promise.all(uploadPromises);
                }
            } else if (this.tenderId && this.cancellationId) {
                request = this.documentsService.save(signFile, this.tenderId, {
                        cancellationId: this.cancellationId,
                        docData: {
                            documentType: 'cancellationReport'
                        }
                    });
            } else if (this.tenderId) {



                 const data = {
                     docData: {
                        documentType: this.$rootScope.edsSignSetup.documentType ? this.$rootScope.edsSignSetup.documentType : 'notice'

                    }
                }

                if(this.$rootScope.edsSignSetup.confidentialityRationale){
                    data.docData.confidentialityRationale = this.$rootScope.edsSignSetup.confidentialityRationale
                }

                if(this.$rootScope.edsSignSetup.confidentiality){
                    data.docData.confidentiality = this.$rootScope.edsSignSetup.confidentiality
                }


                request = signId ?
                    this.documentsService.replace(signFile, this.tenderId, signId) :
                    this.documentsService.save(signFile, this.tenderId, data);
            } else if (this.planId && this.milestoneId) {
                request = signId ?
                    this.documentsService.replace(signFile, this.planId, signId, {
                        milestoneId: this.milestoneId
                    }) :
                    this.documentsService.save(signFile, this.planId, {
                        milestoneId: this.milestoneId
                    });
            } else if (this.planId) {
                request = signId ?
                    this.documentsService.replace(signFile, null, signId, {
                        planId: this.planId
                    }) :
                    this.documentsService.save(signFile, null, {
                        planId: this.planId
                    });
            }

            if (request) {
                request.then((response) => {
                    if (this.planId) this.ntFlash.success(gettext('План підписаний'));
                    else this.ntFlash.success(gettext('Тендер подписан'));
                    if (this.callback) this.callback();
                    if (this.checkPerson){
                        // console.log(this.AP)
                        response.ap = this.AP;
                    }
                    this.close(response);
                }).catch((error => {
                    console.log('Errors: ', error);
                    this.ntFlash.error(gettext('Помилка завантаження підпису'));
                        const errorData  = {
                            currentUrl: `${location.href}`,
                            additionalError: null,
                            message: 'Error from sign b2b',
                            requestUrl: '__',
                            responseCode: '',
                            user: null,
                            requestAction: 'b2b_sign_error_request',
                            requestData: error ? this.stringifyForLog(error) : null,
                            date: new Date(),
                        }
                        this.sendError(errorData)
                        this.ntFlash.error(gettext('Ошибка загрузки цифровой подписи'));

                }));
            } else {
                console.error('Object request is empty!');
            }
        }
    }

    sendError(data){
        this.$http({
            method: 'POST',
            url: 'https://newtend.com/wp-json/slack/v2',
            // Important for sending credentials
            data
        }).then(function successCallback(response) {
            // Handle success
            console.log(response)
        }, function errorCallback(response) {
            // Handle error
            console.error(response)
        });
    }

    // getRawBid() {
    //     return this.http.get(`tender/${this.tenderId}/bid/${this.bidId}/?private_mode=all`)
    //         .then(response => response.data);
    // }
    //
    // prepareArrayBid(bidRaw) {
    //     const resp = {...bidRaw}
    //     delete resp.parameters
    //     delete resp.can_edit
    //     delete resp.isSigned
    //     const clearBid = {...resp}
    //     const bidEmptyValue = {...resp}
    //     if(bidEmptyValue.lotValues){
    //         delete bidEmptyValue.lotValues
    //     }
    //     if(bidEmptyValue.value){
    //         delete bidEmptyValue.value
    //     }
    //     if(bidEmptyValue.items){
    //         bidEmptyValue.items = bidEmptyValue.items.map((el)=>{
    //             return {
    //                 ...el,
    //                 unit: {
    //                     code: el.unit.code,
    //                     name: el.unit.name
    //                 }
    //             }
    //         })
    //     }
    //
    //     return [
    //         clearBid,
    //         bidEmptyValue
    //         ]
    //
    // }
}

providerCabinetApp.component('edsSignBlock', {
    templateUrl: "/static/scripts/modules/Provider/views/components/eds-sign-block.html",
    controller: EdsSignBlock,
    controllerAs: 'vm',
    bindings: {
      edsSignIsOpened: '<',
      edsSignData: '<',
      onResolved: '&'
    }
});
